let showCustomButtons = false;

document.addEventListener('DOMContentLoaded', function () {
	function restartInitialize() {
		if (typeof initialize === 'function') {
			console.log("initialize function exists.");
			if (typeof google === 'undefined' || typeof google.maps === 'undefined') {
				console.log("Google Maps API is not fully loaded. Waiting for it to load...");
				waitForGoogleMapsAPI(initialize);
			} else {
				console.log("Google Maps API is already loaded. Proceeding with initialization.");
				initialize();
			}
		} else {
			console.error("Error: initialize function is not defined.");
		}
		var storeMapDiv = document.getElementById('store_map');
		if (storeMapDiv) {
			console.log("store_map div exists.");
		} else {
			console.error("Error: store_map div is not found in the DOM.");
		}
	}
	function waitForGoogleMapsAPI(callback) {
		if (typeof google === 'undefined' || typeof google.maps === 'undefined') {
			setTimeout(function () {
				waitForGoogleMapsAPI(callback);
			}, 100);
		} else {
			callback();
		}
	}
	restartInitialize();

	var observer = new MutationObserver(handlePopupChanges);
	var config = { childList: true, subtree: true };
	observer.observe(document.querySelector("#sl_addresses"), config);

	const storeMap = document.getElementById("store_map");
	setPins();
	const pinsObserver = new MutationObserver(() => {
		setPins();
	});
	pinsObserver.observe(storeMap, { childList: true, subtree: true });

    const searchInput = document.querySelector("#address_search");
    searchInput.addEventListener("change", () => showCustomButtons = true);

    const submitBtn = document.querySelector("#submitBtn");
    submitBtn.innerHTML = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 50 50" width="50px" height="50px"><path d="M 21 3 C 11.621094 3 4 10.621094 4 20 C 4 29.378906 11.621094 37 21 37 C 24.710938 37 28.140625 35.804688 30.9375 33.78125 L 44.09375 46.90625 L 46.90625 44.09375 L 33.90625 31.0625 C 36.460938 28.085938 38 24.222656 38 20 C 38 10.621094 30.378906 3 21 3 Z M 21 5 C 29.296875 5 36 11.703125 36 20 C 36 28.296875 29.296875 35 21 35 C 12.703125 35 6 28.296875 6 20 C 6 11.703125 12.703125 5 21 5 Z"/></svg>`;
});

function setPins() {
	let pinsList = [];
	let interval = setInterval(() => {
		pinsList = document.querySelectorAll('img[src*="/sc-store-locator-map-24/assets/map-pin-pink.png"]');
		if (pinsList.length) {
			clearInterval(interval);
			pinsList.forEach(pin => {
				pin.src = "https://cdn.shopify.com/s/files/1/0694/9945/3741/files/pin.png";
			});
		}
	}, 100);
}

function handlePopupChanges(mutationsList, observer) {
      const submitBtn = document.querySelector("#submitBtn");
    submitBtn.innerHTML = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 50 50" width="20px" height="20px" fill="#fff"><path d="M 21 3 C 11.621094 3 4 10.621094 4 20 C 4 29.378906 11.621094 37 21 37 C 24.710938 37 28.140625 35.804688 30.9375 33.78125 L 44.09375 46.90625 L 46.90625 44.09375 L 33.90625 31.0625 C 36.460938 28.085938 38 24.222656 38 20 C 38 10.621094 30.378906 3 21 3 Z M 21 5 C 29.296875 5 36 11.703125 36 20 C 36 28.296875 29.296875 35 21 35 C 12.703125 35 6 28.296875 6 20 C 6 11.703125 12.703125 5 21 5 Z"/></svg>`;

    if (showCustomButtons) {
        const locations = document.querySelector("#sl_addresses");
        if (locations) {
            locations.style.display = "block";
        }
    }
	mutationsList.forEach(function (mutation) {
		if (mutation.type === 'childList' && mutation.addedNodes.length > 0) {
			mutation.addedNodes.forEach(function (addedNode) {
				if (addedNode.nodeType === 1) { // we ensure it's an element node
					var storeWebsiteElement = addedNode.querySelector('.name');
					if (storeWebsiteElement) {
						// Check if links are already appended
						if (!storeWebsiteElement.dataset.linkProcessed) {
							var parentElement = storeWebsiteElement.parentElement;

							var popupText = storeWebsiteElement.textContent.trim();
							// Create links for Google Maps and Directions
							var googleMapsLink = 'https://www.google.com/maps/search/?api=1&query=' + encodeURIComponent(popupText);
							var directionsLink = 'https://www.google.com/maps/dir/?api=1&destination=' + encodeURIComponent(popupText);

							// Create "View on Google" link
							var googleLink = document.createElement('a');
							googleLink.href = googleMapsLink;
							googleLink.target = "_blank";
                            googleLink.className = "custom-view-clinic";
							googleLink.textContent = "View clinic";
							googleLink.style.marginTop = "20px";


							// Create "Get Directions" link
							var directionsLinkElem = document.createElement('a');
							directionsLinkElem.href = directionsLink;
							directionsLinkElem.target = "_blank";
                            directionsLinkElem.className = "custom-get-directions"
							directionsLinkElem.textContent = "Get directions";
							directionsLinkElem.style.marginTop = "10px";

							// Append links to the parent element of .name
							parentElement.appendChild(googleLink);
							parentElement.appendChild(directionsLinkElem);

							// Mark the links as processed to avoid duplicate processing
							storeWebsiteElement.dataset.linkProcessed = true;
						}
					}
				}
			});
		}
	});
}